import { useAppStore, type PanelFlyoutId } from '../../state/store';
import { BrushPanel } from './BrushPanel';
import { HistogramPanel } from './HistogramPanel';
import { InfoPanel } from './InfoPanel';
import { PanelEmbedProvider } from './Panel';
import { PropertiesPanel } from './PropertiesPanel';
import { TypePanel } from './TypePanel';

const FLYOUT_TITLES: Record<PanelFlyoutId, string> = {
  info: 'Info',
  properties: 'Properties',
  brush: 'Brush',
  character: 'Character',
  paragraph: 'Paragraph',
  histogram: 'Histogram',
};

function FlyoutBody({ id }: { id: PanelFlyoutId }) {
  switch (id) {
    case 'info':
      return <InfoPanel />;
    case 'properties':
      return <PropertiesPanel />;
    case 'brush':
      return <BrushPanel />;
    case 'character':
      return <TypePanel mode="character" />;
    case 'paragraph':
      return <TypePanel mode="paragraph" />;
    case 'histogram':
      return <HistogramPanel />;
    default:
      return null;
  }
}

/** Docked flyout above the History / Layers stacks, driven by the right rail. */
export function PanelFlyout() {
  const flyout = useAppStore((state) => state.panelFlyout);
  if (!flyout) return null;

  const isType = flyout === 'character' || flyout === 'paragraph';

  return (
    <div className="panel-flyout">
      {!isType && (
        <div className="panel-stack__tabs">
          <span className="panel-stack__tab panel-stack__tab--active">{FLYOUT_TITLES[flyout]}</span>
        </div>
      )}
      <div className="panel-flyout__body">
        {isType ? (
          <FlyoutBody id={flyout} />
        ) : (
          <PanelEmbedProvider>
            <FlyoutBody id={flyout} />
          </PanelEmbedProvider>
        )}
      </div>
    </div>
  );
}
